import React, { useEffect, useRef } from "react";
import { Paragraph, Icon, useColorTokens } from "@tvg/design-system";
import { TabProps } from "../types";
import { Button, ListItem } from "./styled-components";

const Tab = ({
  isActive,
  onClick,
  text,
  qaLabel,
  hasPromo = false,
  onRef
}: TabProps) => {
  const colorTokens = useColorTokens();
  const ref = useRef<HTMLLIElement>(null);

  useEffect(() => (onRef ? onRef(ref) : undefined), []);

  return (
    <ListItem data-qa-label={qaLabel} ref={ref}>
      <Button isActive={isActive} onClick={onClick}>
        {hasPromo && (
          <Icon
            size="s"
            qaLabel="bet-type-button-promo-tag"
            name="promo"
            lineColor={colorTokens.content.alert}
            backgroundColor={colorTokens.background.alertSubtle}
            mr="space-2"
          />
        )}
        <Paragraph
          qaLabel="bet-type-button-text"
          fontFamily="medium"
          color={
            isActive ? colorTokens.content.link : colorTokens.content.default
          }
        >
          {text}
        </Paragraph>
      </Button>
    </ListItem>
  );
};

export default Tab;
